
import Loading from '@/components/Loading.vue'
import { debounce } from 'debounce'
import filterListMixin from '@/mixins/filterListMixin'
import ProductTechnicalFilters from '@/components/ProductTechnicalFilters.vue'
import {
  TECHNICAL_FILTER_QUERY_KEYS,
  hasPendingTechnicalChanges,
  supersededFilterIds,
  technicalFilterApiParams,
} from '@/utils/technicalFilters'
import { priceInputValues, priceQueryValue } from '@/utils/priceFilter'

import Vue from 'vue'

import 'vue-slider-component/theme/default.css'

if (process.client) {
  const VueSlider = require('vue-slider-component')
  Vue.component('VueSlider', VueSlider)
}

export default {
  name: 'FilterList',
  components: { Loading, ProductTechnicalFilters },
  mixins: [filterListMixin],
  props: {
    category: {
      default: null,
      type: Object,
    },
    showAllFilters: {
      default: false,
      type: Boolean,
    },
    showReviewsFilter: {
      default: true,
      type: Boolean,
    },
    productsCount: {
      default: 0,
      type: Number,
    },
    technicalRanges: {
      default: null,
      type: [Object, Array],
    },
    withTechnicalFilters: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      filters: {
        brands: [],
        filters: [],
        reviews: [],
        categories: [],
        structuredData: {},
      },
      vehicle_types: [],
      vehicleTypeSelected: null,
      selectedPriceValues: [0, 0],
      headlightTypesSelected: [],
      sortingSelected: null,
      lowPrice: 0.0,
      highPrice: 0.0,
      lowPriceTouched: false,
      highPriceTouched: false,
      ranges: {},
      fetchingFilters: false,
      headlight_types_list: [],
      headlight_vehicle_details_list: [],
      brandsSelected: this.$route.query.brands
        ? this.$route.query.brands.split(',')
        : [],
      categoriesSelected: this.$route.query.categories
        ? this.$route.query.categories.split(',')
        : [],
      reviewsSelected: this.$route.query.reviews
        ? this.$route.query.reviews.split(',')
        : [],
      textSearch: this.$route.query.search ? this.$route.query.search : null,
      filtersSelected: this.$route.query.filters
        ? this.$route.query.filters.split(',').map(Number)
        : [],
      shakeButton: false,
      technicalPending: {},
    }
  },
  computed: {
    visibleFilters() {
      const superseded = supersededFilterIds(this.technicalRanges)

      return this.filters.filters.filter(
        filter =>
          !superseded.includes(filter.id) ||
          filter.filter_values.some(value =>
            this.filtersSelected.includes(value.id)
          )
      )
    },
    hasActiveFilters() {
      return (
        this.brandsSelected.length > 0 ||
        this.categoriesSelected.length > 0 ||
        this.reviewsSelected.length > 0 ||
        this.textSearch ||
        this.filtersSelected.length > 0 ||
        this.headlightTypesSelected.length > 0 ||
        this.$route.query.price ||
        TECHNICAL_FILTER_QUERY_KEYS.some(key => this.$route.query[key]) ||
        hasPendingTechnicalChanges(this.$route.query, this.technicalPending)
      )
    },
    selectedVehicleId() {
      return this.$store.state.selected_vehicle?.id
    },
  },
  watch: {
    filtersSelected() {
      this.triggerShake()
    },
    headlightTypesSelected() {
      this.triggerShake()
    },
    reviewsSelected() {
      this.triggerShake()
    },
    brandsSelected() {
      this.triggerShake()
    },
    categoriesSelected() {
      this.triggerShake()
    },
    technicalPending() {
      this.triggerShake()
    },
    selectedVehicleId() {
      if (this.$route.query.q) this.fetchFilters()
    },
    $route(to, from) {
      this.technicalPending = {}
      this.lowPriceTouched = false
      this.highPriceTouched = false
      this.syncPriceInputs(this.$route.query.price)
      this.filtersSelected = this.$route.query.filters
        ? this.$route.query.filters.split(',').map(Number)
        : []
      this.brandsSelected = this.$route.query.brands
        ? this.$route.query.brands.split(',').map(Number)
        : []
      this.categoriesSelected = this.$route.query.categories
        ? this.$route.query.categories.split(',').map(Number)
        : []
      this.sortingSelected = this.$route.query.sort
        ? this.$route.query.sort
        : null
      this.reviewsSelected = this.$route.query.reviews
        ? this.$route.query.reviews.split(',').map(Number)
        : []
      this.filters.filters
        .filter(item => item.filter_type_id == 2)
        .forEach(element => {
          this.getFilterSelectedRangeValues(element.id)
        })

      if (!this.$route.query.type) {
        this.headlightTypesSelected = []
      }
      if (
        to.path === from.path ||
        Object.entries(this.$route.query).some(([, v]) => typeof v === 'string')
      ) {
        this.fetchFilters()
      }
    },
  },

  mounted() {
    if (this.$device.isMobile && this.$route.query.sort) {
      this.sortingSelected =
        this.sortingSelect.find(item => item.value == this.$route.query.sort)
          ?.value || null
    }
    if (this.$route.query.type) {
      const typeValue = this.$route.query.type
      if (typeof typeValue === 'string') {
        this.headlightTypesSelected = typeValue.split(',')
      } else {
        this.headlightTypesSelected = [typeValue]
      }
    }
  },

  async fetch() {
    await this.fetchFilters()
    this.syncPriceInputs(this.$route.query.price)
  },

  methods: {
    getFilterSelectedRangeValues(filter_id) {
      let filter = this.filters.filters.find(item => item.id == filter_id)

      if (!filter) return

      let filter_values = filter.filter_values || []

      let array_values_filter = filter_values
        .map(item => parseFloat(item.name.replace(/[^\d.-]/g, '')))
        .sort((a, b) => a - b)

      let filter_values_selected = filter_values.filter(item =>
        this.filtersSelected.includes(item.id)
      )

      let array_values_filter_selected = filter_values_selected
        .map(item => parseFloat(item.name.replace(/[^\d.-]/g, '')))
        .sort((a, b) => a - b)

      if (array_values_filter_selected.length == 0) {
        this.ranges[filter_id] = [
          '' + array_values_filter[0] + '',
          '' + array_values_filter[array_values_filter.length - 1] + '',
        ]
      } else {
        this.ranges[filter_id] = [
          '' + array_values_filter_selected[0] + '',
          '' +
            array_values_filter_selected[
              array_values_filter_selected.length - 1
            ] +
            '',
        ]
      }
    },

    setRangeFiltersSelected: debounce(function (values, filter_id) {
      let filter_values = this.filters.filters.filter(
        item => item.id == filter_id
      )[0].filter_values
      let filter_values_selected = Object.values(
        filter_values
          .filter(
            item =>
              parseFloat(item.name.replace(/[^\d.-]/g, '')) >= values[0] &&
              parseFloat(item.name.replace(/[^\d.-]/g, '')) <= values[1]
          )
          .map(item => item.id)
      )

      this.ranges[filter_id] = values

      if (this.filtersSelected.length > 0) {
        this.filtersSelected = [...this.filtersSelected].filter(item =>
          filter_values.includes(item)
        )
      }

      if (filter_values_selected.length != filter_values.length) {
        this.filtersSelected = [...this.filtersSelected].concat(
          filter_values_selected
        )
      }
    }, 200),

    resetFilters() {
      this.$router.push(
        this.localePath({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            page: undefined,
            sort: undefined,
            filters: undefined,
            categories: undefined,
            type: undefined,
            technologie: undefined,
            brands: undefined,
            reviews: undefined,
            price: undefined,
            ...Object.fromEntries(
              TECHNICAL_FILTER_QUERY_KEYS.map(key => [key, undefined])
            ),
          },
        })
      )
      this.brandsSelected = []
      this.reviewsSelected = []
      this.categoriesSelected = []
      this.textSearch = null
      this.vehicleTypeSelected = undefined
      this.headlightTypesSelected = []
      this.filtersSelected = []
      this.technicalPending = {}
      this.lowPriceTouched = false
      this.highPriceTouched = false
      this.syncPriceInputs(null)
      this.filters.filters
        .filter(item => item.filter_type_id === 2)
        .forEach(element => {
          this.getFilterSelectedRangeValues(element.id)
        })
    },

    async fetchFilters() {
      this.fetchingFilters = true

      const params = {
        'filter[productName]': this.$route.query.q
          ? this.$route.query.q
          : this.$route.params.search
          ? this.$route.params.search
          : undefined,
        'filter[availability]': 'stock,reorder,sold_out',
        'filter[vehiclesIds]': this.$route.query.q
          ? undefined
          : this.$route.params.typeid
          ? this.$route.params.typeid
          : undefined,
        'filter[headlightTypesIds]':
          this.$route.query.type ||
          this.$route.query.headlight_types ||
          undefined,
        'filter[headlightVehicleDetailsIds]':
          this.$route.query.technologie || undefined,
        'filter[priceRange]': this.$route.query.price || undefined,
        ...technicalFilterApiParams(this.$route.query),
        'filter[search]': this.$route.query.q
          ? `name\\l||variant.name\\l`
          : undefined,
      }

      const applyFilters = data => {
        const {
          brands,
          categories,
          filters,
          reviews,
          headlight_types,
          headlight_vehicle_details,
          structuredData,
        } = data
        this.filters.brands = brands
        this.filters.categories = categories
        this.filters.filters = filters.filter(item => item.show_on_product_card)
        this.filters.filters
          .filter(item => item.filter_type_id == 2)
          .forEach(element => {
            this.getFilterSelectedRangeValues(element.id)
          })
        this.filters.reviews = reviews.filter(item => item.stars > 3)
        this.headlight_types_list = headlight_types
        this.headlight_vehicle_details_list = headlight_vehicle_details
        this.filters.structuredData = structuredData
        this.fetchingFilters = false
        this.syncPriceInputs(this.$route.query.price)
      }

      if (this.category) {
        await this.$productService
          .fetchCategoryPageFilters(this.category.id, params)
          .then(applyFilters)
      } else if (this.$route.params.typeid) {
        await this.$vehicleService
          .fetchVehicleSearchPageFilters(this.$route.params.typeid, params)
          .then(applyFilters)
      } else if (this.$route.query.q) {
        await this.$productService
          .fetchSiteSearchFilters({
            ...params,
            q: this.$route.query.q,
            vehicle: this.selectedVehicleId,
          })
          .then(applyFilters)
      } else {
        this.fetchingFilters = false
      }
    },
    useImageFilter(value) {
      if (this.filtersSelected.includes(value)) {
        this.filtersSelected = [...this.filtersSelected].filter(
          item => item !== value
        )
      } else {
        this.filtersSelected.push(value)
      }
    },
    triggerShake() {
      if (!this.shakeButton && this.hasActiveFilters) {
        this.shakeButton = true
        setTimeout(() => {
          this.shakeButton = false
        }, 600)
      }
    },
    syncPriceInputs(price) {
      const { low, high } = priceInputValues(price, this.filters.structuredData)
      if (!this.lowPriceTouched) this.lowPrice = low
      if (!this.highPriceTouched) this.highPrice = high
    },
    applyFilters() {
      this.setUrl()
      if (this.$device.isMobile) {
        this.$bvModal.hide('modalFilters')
      }
    },
    setUrl() {
      setTimeout(() => {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            page: undefined,
            sort: this.sortingSelected ? this.sortingSelected : undefined,
            brands:
              this.brandsSelected.length > 0
                ? this.brandsSelected.join(',')
                : undefined,
            reviews:
              this.reviewsSelected.length > 0
                ? this.reviewsSelected.join(',')
                : undefined,
            filters:
              this.filtersSelected.length > 0
                ? this.filtersSelected.join(',')
                : undefined,
            categories:
              this.categoriesSelected.length > 0
                ? this.categoriesSelected.join(',')
                : undefined,
            search:
              this.textSearch && this.textSearch != ''
                ? this.textSearch
                : undefined,
            price: priceQueryValue(
              {
                low: this.lowPrice,
                high: this.highPrice,
                lowTouched: this.lowPriceTouched,
                highTouched: this.highPriceTouched,
              },
              this.$route.query.price
            ),
            type:
              this.headlightTypesSelected.length > 0
                ? this.headlightTypesSelected.join(',')
                : undefined,
            ...this.technicalPending,
          },
        })
      }, 200)
    },
  },
}
